<template>
  <div>
    <jet-banner />

    <div class="min-h-screen bg-gray-100">
      <nav class="p-2 bg-white border-b border-gray-100 shadow">
        <!-- Primary Navigation Menu -->
        <div class="w-full px-4 mx-auto sm:px-6 lg:px-8">
          <div class="flex justify-between h-16">
            <div class="flex">
              <!-- Logo -->
              <div class="flex items-center flex-shrink-0">
                <a href="/">
                  <img alt="Logo" src="/images/logo.png" class="block w-auto h-20" />
                </a>
              </div>

              <!-- Navigation Links -->
              <div class="hidden space-x-8 sm:-my-px sm:ml-10 sm:flex">
                <nav-link :href="route('home')" :active="route().current('home')">
                  <span class="flex items-center w-full"><i class="mr-2 text-lg bi bi-house" />
                    Beranda</span>
                </nav-link>
                <nav-link :href="route('jadwal')" :active="route().current('jadwal')">
                  <span class="flex items-center w-full"><i class="mr-2 text-lg bi bi-calendar-week" />
                    Jadwal Pelaksanaan</span>
                </nav-link>
                <nav-link :href="route('pendaftar')" :active="route().current('pendaftar')">
                  <span class="flex items-center w-full"><i class="mr-2 text-lg bi bi-people" />
                    Data Pendaftar</span>
                </nav-link>
                <nav-link :href="route('hasil-seleksi')" :active="route().current('hasil-seleksi')">
                  <span class="flex items-center w-full"><i class="mr-2 text-lg bi bi-list-check" />
                    Hasil Seleksi</span>
                </nav-link>
                <nav-link :href="route('perguruan-tinggi')" :active="route().current('perguruan-tinggi')">
                  <span class="flex items-center w-full"><i class="mr-2 text-lg bi bi-mortarboard" />
                    Perguruan Tinggi</span>
                </nav-link>
              </div>
            </div>

            <div class="hidden space-x-8 sm:-my-px sm:ml-10 sm:flex">
              <nav-link v-if="$page.props.user" :href="route('home')" :active="route().current('home')">
                <span class="flex items-center w-full"><i class="mr-2 text-lg bi bi-house" />
                  Dashboard</span>
              </nav-link>
              <div v-else class="hidden space-x-8 sm:-my-px sm:ml-10 sm:flex">
                <nav-link v-if="!isReadOnly()" :href="route('register')" class="block px-4 py-2 text-xs text-gray-400">
                  <span class="flex items-center w-full"><i class="mr-2 text-lg bi bi-pencil-square" />
                    Daftar</span>
                </nav-link>
                <nav-link :href="route('login')" class="block px-4 py-2 text-xs text-gray-400">
                  <span class="flex items-center w-full"><i class="mr-2 text-lg bi bi-unlock" />
                    Login</span>
                </nav-link>
              </div>
            </div>

            <!-- Hamburger -->
            <div class="flex items-center -mr-2 sm:hidden">
              <button aria-label="Open Menu" class="inline-flex items-center justify-center p-2 text-gray-400 transition duration-150 ease-in-out rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500" @click="showingNavigationDropdown = ! showingNavigationDropdown">
                <svg class="w-6 h-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                  <path :class="{'hidden': showingNavigationDropdown, 'inline-flex': ! showingNavigationDropdown }" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                  <path :class="{'hidden': ! showingNavigationDropdown, 'inline-flex': showingNavigationDropdown }" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div :class="{'block': showingNavigationDropdown, 'hidden': ! showingNavigationDropdown}" class="sm:hidden">
          <div v-if="$page.props.user" class="flex h-full min-h-screen p-4 bg-white sm:w-full">
            <side-bar :showing-side-bar="true" />
          </div>
          <div v-else class="pt-2 pb-3 mt-6 space-y-1">
            <responsive-nav-link :href="route('home')" :active="route().current('home')">
              <span class="flex items-center w-full"><i class="mr-2 text-lg bi bi-house" />
                Home </span>
            </responsive-nav-link>
            <responsive-nav-link :href="route('perguruan-tinggi')" :active="route().current('perguruan-tinggi')">
              <span class="flex items-center w-full"><i class="mr-2 text-lg bi bi-mortarboard" />
                Perguruan Tinggi </span>
            </responsive-nav-link>
            <responsive-nav-link :href="route('jadwal')" :active="route().current('jadwal')">
              <span class="flex items-center w-full"><i class="mr-2 text-lg bi bi-calendar-week" />
                Jadwal Pelaksanaan</span>
            </responsive-nav-link>
            <responsive-nav-link :href="route('pendaftar')" :active="route().current('pendaftar')">
              <span class="flex items-center w-full"><i class="mr-2 text-lg bi bi-people" />
                Data Pendaftar</span>
            </responsive-nav-link>
            <responsive-nav-link :href="route('hasil-seleksi')" :active="route().current('hasil-seleksi')">
              <span class="flex items-center w-full"><i class="mr-2 text-lg bi bi-list-check" />
                Hasil Seleksi</span>
            </responsive-nav-link>
            <responsive-nav-link v-if="!isReadOnly()" :href="route('register')" :active="route().current('register')">
              <span class="flex items-center w-full"><i class="mr-2 text-lg bi bi-pencil-square" />
                Daftar</span>
            </responsive-nav-link>
            <responsive-nav-link :href="route('login')" :active="route().current('login')">
              <span class="flex items-center w-full"><i class="mr-2 text-lg bi bi-unlock" />
                Login</span>
            </responsive-nav-link>
          </div>
        </div>
      </nav>

      <!-- Page Heading -->
      <header v-if="$slots.header" class="bg-white shadow">
        <div class="container flex flex-wrap justify-between p-6 mx-auto max-w-8xl">
          <h2 class="text-sm leading-tight text-pink-500 ">
            <Link class="font-semibold" href="/"> Beranda </Link>
            <slot name="header" />
          </h2>
        </div>
      </header>

      <!-- Page Content -->
      <main>
        <flash-messages />
        <slot />
      </main>
    </div>
  </div>
</template>

<script>
import FlashMessages from '../Shared/FlashMessages.vue'
import NavLink from '../Shared/NavLink.vue'
import ResponsiveNavLink from '../Shared/ResponsiveNavLink.vue'

export default {
  components: {
    FlashMessages,
    NavLink,
    ResponsiveNavLink,
  },

  data() {
    return {
      showingNavigationDropdown: false,
      showingSideBar : true,
    }
  },
  watch:{
    showingSideBar : function(){
      localStorage.setItem('sideBarShowing', JSON.stringify(this.showingSideBar))
    },
  },
  mounted(){
    this.showingSideBar = JSON.parse(localStorage.getItem('sideBarShowing')) ?? true
  },

  methods: {

  },
}
</script>
